<template>
  <div class="d-flex flex-wrap flex-column flex-sm-row justify-content-between">
    <div>
      <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
        Campaign Details
      </div>
      <div class="d-flex align-items-center w-100 cursor-pointer">
        <BackRoute />
      </div>
    </div>
    <div class="d-flex mt-2 my-1 link">
      <div
        @click="toggleQRCode"
        class="justify-content-center cursor-pointer border-radius-8 px-3 py-3 mr-3 d-flex"
        style="background-color: #ebedff"
      >
        <div class="mr-2">
          <BarCodeIcon class="w-12 h-12 primary--text" />
        </div>
        <div style="color: #0e4cb5" class="s-16">Qr code</div>
      </div>
      <div
        class="justify-content-center cursor-pointer border-radius-8 px-3 py-3 d-flex"
        style="background-color: #ebedff"
      >
        <div class="mr-2"><CopyIcon class="w-12 h-12" /></div>
        <div style="color: #0e4cb5" class="s-16">Copy link</div>
      </div>
    </div>
  </div>
  <div class="container-fluid px-0 mt-5">
    <div class="align-items-center card border-gray-50 py-4 px-5">
      <div class="row">
        <!-- Image -->
        <div class="col-md-4 text-center card-img-container">
          <img
            src="../../../assets/tempImage/healthcampaign.png"
            alt="Kids Health Care Mission"
            class="campaign-image rounded-lg"
          />
        </div>

        <!-- Campaign Content -->
        <div class="col-md-7 mt-md-0">
          <div class="fw-500 s-32 mt-3 text-black">
            Kids Health Care Mission
          </div>
          <div class="s-16 fw-300 mt-2 text-dak">
            The Kids' Health Care Mission is a dedicated campaign focused on
            ensuring every child has access to the essential healthcare they
            deserve. We believe that a healthy childhood is the foundation for a
            brighter future, and this mission is committed to making that vision
            a reality.
            <span class="font-weight-bold text-dak" style="font-style: italic"
              >Read more</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Info -->
    <div class="row mt-4 align-items-center">
      <div class="col-md-3 col-6 text-center text-md-left">
        <div class="s-16 text-dak">Started</div>
        <p style="color: #4b4848" class="fw-500 mb-0">25th May 2025</p>
      </div>

      <div class="col-md-3 col-6 text-center text-md-left">
        <div class="s-16 text-dak">To end</div>
        <p style="color: #4b4848" class="fw-500 mb-0">25th August 2025</p>
      </div>

      <!-- Dropdown -->
      <div class="col-md-6 col-12">
        <div class="d-flex flex-column flex-sm-row justify-content-between">
          <div class="mt-3 mt-md-0 text-center w-100 mr-0 mr-sm-3">
            <el-dropdown
              trigger="click"
              @command="handleCommand"
              class="w-100 border-gray-400 p-sm-2 py-3 px-3 border-radius-60 h-100"
              style="max-height: 48px"
            >
              <div
                class="d-flex justify-content-between align-items-center px-2 w-100"
                size="large"
              >
                <span class="el-dropdown-link fw-500" style="color: #302d2d">
                  {{ statusLabel }}
                </span>
                <div>
                  <el-icon style="color: #6f6f6f" :size="18"
                    ><CaretBottom
                  /></el-icon>
                </div>
              </div>

              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="active">Active</el-dropdown-item>
                  <el-dropdown-item command="paused">Paused</el-dropdown-item>
                  <el-dropdown-item command="ended">Ended</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>

          <!-- Button -->
          <div class="mt-md-0 mt-3 text-center text-md-right w-100">
            <el-button
              :color="primarycolor"
              class="text-white py-4 w-100"
              size="large"
              round
              >Extend Campaign</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid mt-5 px-0"><CampaignMetrics /></div>
  <el-dialog
    v-model="displayQrCode"
    title=""
    :width="mdAndUp || lgAndUp || xlAndUp ? `30%` : xsOnly ? `90%` : `70%`"
    class="QRCodeDialog"
    align-center
  >
    <div class="d-flex align-items-center flex-column">
      <div class="text-capitalize s-20 fw-500 text-black font-weight">
        Scan QR Code to Pay
      </div>
      <div class="s-14" style="color: #737373">
        Scan the Code below with your smartphone
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="img-wrapper">
        <img
          v-if="qrCodeForCampaign"
          :src="qrCodeForCampaign"
          class="image-wrapper w-100"
        />
        <img
          v-else
          src="../../../assets/qrcode.png"
          class="image-wrapper w-100"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script setup>
import BackRoute from "../../../components/backroute/BackRoute.vue";
import { ref, computed, inject } from "vue";
import CopyIcon from "../../../components/icons/CopyIcon.vue";
import BarCodeIcon from "../../../components/icons/BarCodeIcon.vue";
import CampaignMetrics from "./components/CampaignMetrics.vue";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";

const status = ref("active");
const qrCodeForCampaign = ref("");
const primarycolor = inject("primarycolor");
const displayQrCode = ref(false);
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();

const statusLabel = computed(() => {
  if (status.value === "active") return "Active";
  if (status.value === "paused") return "Paused";
  if (status.value === "ended") return "Ended";
  return "Active";
});

const toggleQRCode = () => {
  displayQrCode.value = true;
};

function handleCommand(command) {
  status.value = command;
}
</script>

<style scoped>
.card {
  border-radius: 15px;
}
.card-img-container {
  height: 255px;
  overflow: hidden;
}

.campaign-image {
  border-radius: 7px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}
</style>
